// @flow

import routes from 'app/settings/routes';

export default {
  routes,
};
